export const MIN_NAME_LENGTH = 3;

export const validateName = (name: string | null | undefined): 'too_short' | undefined =>
    (name ?? '').trim().length < MIN_NAME_LENGTH ? 'too_short' : undefined;
